import createRequest from "../network/createRequest.js"
import decorateConfig from "./decorateConfig.js"

export default createRequest({ decorateConfig });